const Validator = {
    reqText : function(txt, min = 2, max = 100){
        return (txt && txt.length > min && txt.length < max);
    },

    email : function(email){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    required : function(str){
        return (str && str.length > 0);
    },

    password : function(str){
        return (str && str.length > 5);
    },

    phone : function(str) {
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        return str.match(phoneno);
    },

    img_upload : function(str, $input){
        try{
            let file = $input[0].files[0];
            let name = file.name;
            let size = file.size / 1000000;
            let extension = name.split('.').pop().toLowerCase();
            let isValid = true;
            if(extension.indexOf("jpg") < 0 && extension.indexOf("jpeg") < 0 && extension.indexOf("png") < 0)
                isValid = false;
            if(size > 5000000)
                isValid = false;
            return isValid;
        }
        catch(e){
            return false
        }
    }
};

module.exports = Validator;


// WEBPACK FOOTER //
// ./src/control/util/Validator.js